import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link, useLocation } from 'react-router-dom';

import { useNavigationPaths } from 'hooks/useNavigationPaths';

import { PRIVACY_FRAGMENT, TERMS_FRAGMENT } from './privacy-policy/constants';

export interface FooterProps {
  accountName: string;
}

export function Footer({ accountName }: FooterProps) {
  const { privacyPath } = useNavigationPaths();
  // Preserve the selected locale (kept in ?locale=…) and stay within React
  // Router instead of force-reloading the page via a bare anchor.
  const { search } = useLocation();

  return (
    <footer className="mt-auto border-t border-gray-200 bg-white py-6 text-center text-sm text-gray-600">
      <Link
        to={{ pathname: privacyPath, search, hash: `#${PRIVACY_FRAGMENT}` }}
        className="underline hover:text-gray-900"
        data-testid="footer-privacy-link"
      >
        <FormattedMessage
          defaultMessage="{accountName} Privacy Policy"
          description="Footer link to the career site privacy policy section"
          values={{ accountName }}
        />
      </Link>
      <span className="mx-2" aria-hidden="true">
        |
      </span>
      <Link
        to={{ pathname: privacyPath, search, hash: `#${TERMS_FRAGMENT}` }}
        className="underline hover:text-gray-900"
        data-testid="footer-terms-link"
      >
        <FormattedMessage
          defaultMessage="Terms of Service"
          description="Footer link to the career site terms of service section"
        />
      </Link>
    </footer>
  );
}
